import React, { useMemo } from "react";
import { motion, useReducedMotion }  from "framer-motion";

const FadeInAnimation = ({
  children,
  duration = 0.4,
  yOffset = 0,
  easing = "easeInOut",
  delayOrder,
  delaySeconds,
  inView,
  ...otherProps
}) => {
  const reduceMotion = useReducedMotion();
  const delay = delaySeconds ?? (delayOrder ? delayOrder * 0.4 : 0.25);



  const transition = useMemo(
    () => ({
      duration: reduceMotion ? 0 : duration,
      delay: reduceMotion ? 0 : delay,
      ease: easing
    }),
    [delay, duration, easing, reduceMotion]
  );

  const variants = {
    hidden: { 
      y: reduceMotion ? 0 : yOffset,
      opacity: 0,
      transition
    },
    show: {
      y: 0,
      x: 0,
      opacity: 1,
      transition
    }
  };

  return (
    <motion.div
      initial={reduceMotion ? false : "hidden"}
      animate={reduceMotion || inView ? "show" : "hidden"}
      variants={variants}
      {...otherProps}
    >
      {children}
    </motion.div>
  );
};

export default FadeInAnimation;
